module.exports = __webpack_public_path__ + "img/zhaopin_banner.82770f5f.png";